// extracted by mini-css-extract-plugin
export var downArrow = "_a6-0";
export var label = "_a6-1";
export var treatmentCard = "_a6-3";
export var upArrow = "_a6-2";